import React from 'react';
import { Button } from '../components/ui/button';
import { MapPin, Navigation, Phone, MessageCircle } from 'lucide-react';
import { villaData } from '../data/mockData';

export const LocationPage = () => {
  const handleDirections = () => {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${villaData.coordinates.lat},${villaData.coordinates.lng}`, '_blank');
  };
  
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${villaData.whatsapp.replace(/[^0-9]/g, '')}?text=Salam, yer haqqında məlumat almaq istəyirəm`, '_blank');
  };
  
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Yer və Yönəliş
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Quba'nın təbii gözəlliklari arasında yerləşir
          </p>
        </div>
        
        {/* Map */}
        <div className="mb-12 rounded-2xl overflow-hidden shadow-2xl border-4 border-green-100">
          <iframe
            src={`https://www.google.com/maps?q=${villaData.coordinates.lat},${villaData.coordinates.lng}&hl=az&z=14&output=embed`}
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Villa Location"
          ></iframe>
        </div>
        
        {/* Location Info */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Address Card */}
          <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 border border-green-100">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Ünvan</h2>
                <p className="text-lg text-gray-700">{villaData.location}</p>
              </div>
            </div>
            
            <div className="space-y-3 mb-6">
              <p className="text-gray-700">
                <strong>Koordinatlar:</strong> {villaData.coordinates.lat}, {villaData.coordinates.lng}
              </p>
            </div>
            
            <Button
              onClick={handleDirections}
              className="w-full bg-green-600 hover:bg-green-700 text-white"
              size="lg"
            >
              <Navigation className="w-5 h-5 mr-2" />
              Yönəlişi Göstər
            </Button>
          </div>
          
          {/* How to Get There */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Ora Necə Çatmaq Olar?</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                  <span className="w-8 h-8 bg-green-100 text-green-700 rounded-full flex items-center justify-center mr-3 text-sm font-bold">1</span>
                  Bakıdan Qubaya
                </h3>
                <p className="text-gray-700 ml-11">
                  Bakı-Quba yolu ilə təxminən 2.5-3 saat sürür (~170 km)
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                  <span className="w-8 h-8 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center mr-3 text-sm font-bold">2</span>
                  Quba Şəhərindən
                </h3>
                <p className="text-gray-700 ml-11">
                  Quba şəhər mərkəzindən Nügədi 1 kəndinə təxminən 10-15 dəqiqə
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                  <span className="w-8 h-8 bg-green-100 text-green-700 rounded-full flex items-center justify-center mr-3 text-sm font-bold">3</span>
                  Yönəliş
                </h3>
                <p className="text-gray-700 ml-11">
                  Dəqiq yönəliş üçün bizimlə əlaqə saxlayın, sizə kömək edərəm
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Nearby Attractions */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 lg:p-12 mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Yaxınlıqda Gorməli Yerlər
          </h2>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="font-semibold text-gray-900 mb-2">Əfiçatay şəlaləsi</h3>
              <p className="text-gray-600 text-sm">Gözəl təbiət mənzərəsi və şəlalə</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="font-semibold text-gray-900 mb-2">Quba Soyuqbulaq</h3>
              <p className="text-gray-600 text-sm">Təbii bulaq və istirahət zonaları</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="font-semibold text-gray-900 mb-2">Xınaliq kəndi</h3>
              <p className="text-gray-600 text-sm">Tarixi kənd və dağ mənzərələri</p>
            </div>
          </div>
        </div>
        
        {/* Contact CTA */}
        <div className="bg-gradient-to-br from-green-600 to-blue-600 rounded-2xl p-8 lg:p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Yönəliş ilə bağlı sualınız var?</h2>
          <p className="text-xl text-green-50 mb-6">
            Bizimlə əlaqə saxlayın, sizə kömək edək
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={`tel:${villaData.phone}`}>
              <Button size="lg" className="w-full sm:w-auto bg-white text-green-700 hover:bg-gray-100">
                <Phone className="w-5 h-5 mr-2" />
                Zəng Et
              </Button>
            </a>
            <Button
              size="lg"
              onClick={handleWhatsApp}
              className="w-full sm:w-auto bg-green-800 hover:bg-green-900 text-white"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};